import React, { useCallback } from 'react';
import { generatePath } from 'react-router-dom';
import CallRecordItemV2 from 'flow/components/call-history-v2/CallRecordItemV2';
import { DateGroupedRowProps } from 'flow/components/call-history-v2/DateGroupedList';
import ListRowFrame from 'flow/components/nav/list-keys/ListRowFrame';
import { CallRecordKey, QueueKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';
import { saveQueueScrollPosition } from '../queue-scroll-position';

// The row gets its call as a key, not as a row object. The list makes new row
// objects each time its data changes, so a row object would render every row
// each time.
interface Props extends DateGroupedRowProps {
    callRecordKey: CallRecordKey;
    queueKey: QueueKey;
}

const HistoryCallRecordItem = ({
    callRecordKey,
    queueKey,
    index,
    tabStopStore,
    tabStopKey,
    onUnmountWithFocus,
}: Props) => {
    // One function for the life of the row, so the card keeps its render
    // when the row gets a new index, as when a call comes in above it.
    const saveScrollPosition = useCallback(
        () => saveQueueScrollPosition(queueKey),
        [queueKey],
    );

    return (
        <ListRowFrame
            index={index}
            isFocusable={true}
            tabStopStore={tabStopStore}
            tabStopKey={tabStopKey}
            onUnmountWithFocus={onUnmountWithFocus}
        >
            {/* The link is the contact name inside the card, stretched over
                the whole card, so the call button, the menu, the player and
                Mark as handled sit beside it rather than inside a link. */}
            <CallRecordItemV2
                callRecordKey={callRecordKey}
                queueKey={queueKey}
                showMarkIsHandledIfMissed={true}
                segmentContext="PBX history"
                pageType="pbx"
                linkTo={generatePath(
                    routes['pbx.queues.queueKey.callRecordKey'],
                    { queueKey, callRecordKey },
                )}
                onLinkClick={saveScrollPosition}
            />
        </ListRowFrame>
    );
};

export default React.memo(HistoryCallRecordItem);
